export const PACKAGE_VERSION = '1.8.12';
//# sourceMappingURL=constants.js.map